import Vue from "vue";
import store from "./store/index";
import _ from "lodash";

Vue.directive("allow", {
  bind(el, binding) {
    el.addEventListener("keydown", (e) => {
      if (el.id == "login-password" || el.id == "license-input") return;
      let value = e.target.value;
      if (
        binding.modifiers["decimal"] &&
        (e.keyCode == 190 || e.keyCode == 110) &&
        value.indexOf("." == -1)
      ) {
        if (value == "") {
          e.target.value = 0;
          return;
        } else if (
          value != "" &&
          value.indexOf(".") == -1 &&
          e.target.valueAsNumber != NaN
        ) {
          return;
        }
        e.preventDefault();
      }

      if (
        binding.modifiers["alpha"] &&
        // a-z/A-Z
        e.keyCode >= 65 &&
        e.keyCode <= 90
      ) {
        return;
      }
      if (
        binding.modifiers["number"] &&
        // number keys without shift
        ((!e.shiftKey && e.keyCode >= 48 && e.keyCode <= 57) ||
          // numpad number keys
          (e.keyCode >= 96 && e.keyCode <= 105))
      ) {
        if (
          binding.modifiers.hasOwnProperty("phone") &&
          binding.modifiers.phone
        ) {
          if (value.length == 0 && e.key == 0) return e.preventDefault();
          if (
            value.length <=
            store.state.system.country_details.phone_digit - 1
          )
            return;
        } else return;
      }
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Ctrl + V
        (e.keyCode === 86 && e.ctrlKey === true) ||
        // Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 40)
      )
        return;

      if (
        // Ctrl+A
        (e.keyCode === 65 && e.metaKey === true) ||
        // Ctrl+C
        (e.keyCode === 67 && e.metaKey === true) ||
        // Ctrl + V
        (e.keyCode === 86 && e.metaKey === true) ||
        // Ctrl+X
        (e.keyCode === 88 && e.metaKey === true)
      )
        return;

      e.preventDefault();
    });
  },
});

Vue.directive("prodmaxqty", {
  bind(el) {
    el.addEventListener("input", (e) => {
      let value = e.target.value;
      if (
        parseInt(Math.ceil(value)) >
        parseInt(store.state.system.settings.cart.product_max_qty)
      ) {
        if (
          parseInt(value) ==
          parseInt(store.state.system.settings.cart.product_max_qty)
        ) {
          return e.preventDefault();
        } else {
          e.target.value = value.slice(0, value.length - 1);
        }
        return;
      } else if (
        parseInt(value) ==
        parseInt(store.state.system.settings.cart.product_max_qty)
      ) {
        e.preventDefault();
      }
      if (
        [46, 8, 9, 27, 13, 190, 110].indexOf(e.keyCode) !== -1 ||
        // Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Ctrl+v
        (e.keyCode === 86 && e.ctrlKey === true) ||
        // Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        return;
      }
      if (
        // Ctrl+A
        (e.keyCode === 65 && e.metaKey === true) ||
        // Ctrl+C
        (e.keyCode === 67 && e.metaKey === true) ||
        // Ctrl+v
        (e.keyCode === 86 && e.metaKey === true) ||
        // Ctrl+X
        (e.keyCode === 88 && e.metaKey === true)
      ) {
        return;
      }
      e.preventDefault();
    });
  },
});

Vue.directive("max-qty", {
  bind(el, binding, vnode) {
    el.addEventListener("keydown", (e) => {
      if (binding.modifiers["int"] && (e.keyCode == 190 || e.keyCode == 110))
        return e.preventDefault();
    });
    el.addEventListener("input", (e) => {
      let value = e.target.value;
      const available_value = binding.value.available;
      if (available_value < value || value == 0)
        e.target.value = value.slice(0, value.length - 1);
      if (binding.modifiers["update-voucher"])
        vnode.context.updateGroupQty({
          gv_group_id: _.split(e.target.id, "-")[1],
          selected: [],
          action_type: "group_qty_update",
          quantity: e.target.value,
          value_type: _.split(e.target.id, "-")[2],
          sale_value: _.split(e.target.id, "-")[3],
          gift_value: _.split(e.target.id, "-")[4],
        });
    });
  },
});

Vue.directive("negative-disable", {
  bind(el) {
    el.addEventListener("keydown", (e) => {
      if (e.code == "Minus" || e.key == "-") return e.preventDefault();
    });
  },
});
